/* eslint-disable */
/* eslint-disable max-len */
import React, { useEffect, useCallback, useContext } from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import NotificationBadge, { Effect } from 'react-notification-badge';
import _ from 'lodash';
import Application from './application/container/ApplicationContainer';
import ApplicationSmartCity from './application/container/ApplicationContainerSmartCity';
import TaxClearance from './tax-clearance/container/TaxClearanceContainer';
import SettingsContainer from './settings/SettingsContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import CmsContext from '../../context/CmsContext';
import * as actions from './tax-clearance/action';
import * as c from './tax-clearance/constant';

function RPTContainer({ match, getTransactionCount, transactionCount, permissions }) {
  const cmsContext = useContext(CmsContext);

  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const newApplicationCounts = _.get(transactionCount, 'new_applications.TAX CLEARANCE');

  const updateListCountData = useCallback(() => {
    getTransactionCount();
  }, [transactionCount]);

  useEffect(() => {
    if (Acl(permissions, ['VIEW RPTAX CLEARANCE'])) {
      updateListCountData();
    }

    return () => {
      ['formData'].forEach(data =>
        localStorage.removeItem(data)
      );
    };
  }, []);

  return (
    <div className="module-inner">
      <div className="module-inner-title">RPTAX</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/real-property-tax"
        >
          Dashboard
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/real-property-tax/application"
        >
          Tax Payment
        </NavLink>
        {Acl(permissions, ['VIEW RPTAX CLEARANCE']) && !_.get(CMS_COMPONENTS, "SMART_CITY_RPTAX_SETTINGS") && (
          <NavLink
            exact={false}
            className="nav-link position-relative"
            activeClassName="active"
            to="/real-property-tax/tax-clearance"
          >
            <div
              className="position-absolute fixed-top fixed-right"
              style={{ zIndex: '1' }}
            >
              <NotificationBadge
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  height: '25px',
                  width: '25px',
                  top: '2px',
                  right: '7px',
                }}
                count={newApplicationCounts}
                effect={Effect.SCALE}
              />
            </div>
            Tax Clearance
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SETTING RPTAX']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/real-property-tax/settings"
          >
            Settings
          </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        {_.get(CMS_COMPONENTS, "SMART_CITY_RPTAX_SETTINGS") ? (<Route path={`${match.path}/application`} component={ApplicationSmartCity} />) : (<Route path={`${match.path}/application`} component={Application} />)}
        {Acl(permissions, ['VIEW RPTAX CLEARANCE']) && (
          <Route path={`${match.path}/tax-clearance`} component={TaxClearance} />
        )}
        {Acl(permissions, ['VIEW SETTING RPTAX']) && (
          <Route path={`${match.path}/settings`} component={SettingsContainer} />
        )}
      </Switch>
    </div>
  );
}

RPTContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  transactionCount: PropTypes.instanceOf(Object).isRequired,
  getTransactionCount: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  transactionCount: _.get(api, `${c.GET_TRANSACTION_COUNT}.res`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RPTContainer);
